/**
 * Qué períodos se le pueden ofrecer a quien está inscribiendo alumnos.
 *
 * Vive acá, y no como un `.filter()` suelto dentro de la pantalla, porque la
 * regla ya se rompió una vez en silencio: la inscripción directa filtraba por
 * `status === 'open'` y dejaba el desplegable VACÍO en todo tenant cuyo período
 * ya había arrancado —que es el caso normal cuando una cohorte se inscribe
 * tarde—. Un filtro que no encuentra nada no se ve como un defecto: se ve como
 * si no hubiera datos.
 */

/** `TermStatus` del dominio más los valores heredados que todavía hay en datos
 *  viejos (p.ej. `'active'`), porque la pantalla lee el documento crudo. */
export interface TermOption {
  id: string;
  name: string;
  status: string;
}

/**
 * Los períodos elegibles: todos menos el cerrado.
 *
 * - `in_progress` ENTRA: un período en curso es justamente cuando llega quien se
 *   inscribe tarde.
 * - `planned` ENTRA: cargar una cohorte antes de que abra el período es una
 *   preparación legítima.
 * - `closed` queda fuera: inscribir en un período terminado no es un caso, es
 *   un error de dedo.
 */
export function selectableTerms<T extends TermOption>(terms: T[]): T[] {
  return terms.filter((term) => term.status !== 'closed');
}
